<template>
  <div class="full_container" @click="showOptions = false" v-if="!loader">
    <build-components :newItem="newItem" :reserved_items="reserved_items" :quantities="quantities"
      :SubstractQuanity="SubstractQuanity" :RemoveItem="RemoveItem" :AddQuanity="AddQuanity" :indexes="indexes"
      :listSections="listSections" :restaurant="currentRestau ? currentRestau : {}" :currentTab="currentTab"
      :setCurrentTab="setCurrentTab" :currentCurrency="currentCurrency"
      v-if="newItem[currentLang].indexTemplate == '0' && 1 != 1" :currentLang="currentLang"
      :selectedLangues="selectedLangues" :addToCart="triggerAddToCart" :selectes_ids="selectes_ids">
    </build-components>
    <!-- ************************* THEMES ********************** -->
    <div class="container" v-else>
      <second-theme v-if="newItem[currentLang].theme == 2 && 1 != 1" :currentLang="currentLang" :newItem="newItem"
        :reserved_items="reserved_items" :quantities="quantities" :restaurant="currentRestau ? currentRestau : {}"
        :listSections="listSections" :currentTab="currentTab" :setCurrentTab="setCurrentTab"
        :currentCurrency="currentCurrency" :addToCart="triggerAddToCart" :SubstractQuanity="SubstractQuanity"
        :RemoveItem="RemoveItem" :AddQuanity="AddQuanity" :indexes="indexes"></second-theme>
      <third-theme v-if="newItem[currentLang].theme == 3 && 1 != 1" :currentLang="currentLang" :newItem="newItem"
        :reserved_items="reserved_items" :quantities="quantities" :restaurant="currentRestau ? currentRestau : {}"
        :listSections="listSections" :currentTab="currentTab" :setCurrentTab="setCurrentTab"
        :currentCurrency="currentCurrency" :addToCart="triggerAddToCart" :SubstractQuanity="SubstractQuanity"
        :RemoveItem="RemoveItem" :AddQuanity="AddQuanity" :indexes="indexes"></third-theme>
      <monresto-theme v-if="newItem[currentLang].theme == 6 ||
        newItem[currentLang].theme == 1 ||
        1 == 1
        " :currentLang="currentLang" :newItem="newItem" :reserved_items="reserved_items" :quantities="quantities"
        :restaurant="currentRestau ? currentRestau : {}" :listSections="listSections" :currentTab="currentTab"
        :setCurrentTab="setCurrentTab" :currentCurrency="currentCurrency" :addToCart="triggerAddToCart"
        :changeName="changeName" :SubstractQuanity="SubstractQuanity" :RemoveItem="RemoveItem" :AddQuanity="AddQuanity"
        :indexes="indexes" :suggestions="suggesteditems" @itemSelectedToIndex="SelectedItemFromTheme">
      </monresto-theme>

      <seven-theme v-if="newItem[currentLang].theme == 7 && 1 != 1" :currentLang="currentLang" :newItem="newItem"
        :reserved_items="reserved_items" :quantities="quantities" :restaurant="currentRestau ? currentRestau : {}"
        :listSections="listSections" :currentTab="currentTab" :setCurrentTab="setCurrentTab"
        :currentCurrency="currentCurrency" :addToCart="triggerAddToCart" :SubstractQuanity="SubstractQuanity"
        :RemoveItem="RemoveItem" :AddQuanity="AddQuanity" :indexes="indexes"></seven-theme>
      <classic-seven-theme v-if="newItem[currentLang].theme == 12 && 1 != 1" :currentLang="currentLang" :newItem="newItem"
        :reserved_items="reserved_items" :quantities="quantities" :restaurant="currentRestau ? currentRestau : {}"
        :listSections="listSections" :currentTab="currentTab" :setCurrentTab="setCurrentTab"
        :currentCurrency="currentCurrency" :addToCart="triggerAddToCart" :SubstractQuanity="SubstractQuanity"
        :RemoveItem="RemoveItem" :AddQuanity="AddQuanity" :indexes="indexes">
      </classic-seven-theme>
      <custom-theme v-if="newItem[currentLang].theme == 999 && 1 != 1" :currentLang="currentLang" :newItem="newItem"
        :reserved_items="reserved_items" :quantities="quantities" :restaurant="currentRestau ? currentRestau : {}"
        :listSections="listSections" :currentTab="currentTab" :setCurrentTab="setCurrentTab"
        :currentCurrency="currentCurrency" :theme="theme" :addToCart="triggerAddToCart"
        :SubstractQuanity="SubstractQuanity" :RemoveItem="RemoveItem" :AddQuanity="AddQuanity" :indexes="indexes">
      </custom-theme>

      <azour-theme v-if="newItem[currentLang].theme == 14 && 1 != 1" :currentLang="currentLang" :newItem="newItem"
        :reserved_items="reserved_items" :quantities="quantities" :restaurant="currentRestau ? currentRestau : {}"
        :listSections="listSections" :currentTab="currentTab" :setCurrentTab="setCurrentTab"
        :currentCurrency="currentCurrency" :theme="theme" :selectedLangues="selectedLangues" :addToCart="triggerAddToCart"
        :selectes_ids="selectes_ids" :SubstractQuanity="SubstractQuanity" :RemoveItem="RemoveItem"
        :AddQuanity="AddQuanity" :indexes="indexes">
      </azour-theme>
      <swigi-theme v-if="newItem[currentLang].theme == 13 && 1 != 1" :currentLang="currentLang" :newItem="newItem"
        :reserved_items="reserved_items" :quantities="quantities" :restaurant="currentRestau ? currentRestau : {}"
        :listSections="listSections" :currentTab="currentTab" :setCurrentTab="setCurrentTab"
        :currentCurrency="currentCurrency" :theme="theme" :selectedLangues="selectedLangues" :addToCart="triggerAddToCart"
        :selectes_ids="selectes_ids" :SubstractQuanity="SubstractQuanity" :RemoveItem="RemoveItem"
        :AddQuanity="AddQuanity" :indexes="indexes">
      </swigi-theme>
    </div>

    <!--<div :class="`more_options ${showOptions ? 'shown' : ''}`" @click.stop="showOptions = !showOptions">
      <img src="htttp://localhost:3333/info.png" alt="" class="options rotating" />
    </div>
    <more-options @clickParent="() => { showOptions = true }" :changeLangue="changeLangue" :showOptions="showOptions"
      :restau="currentRestau ? currentRestau : {}" :currentLang="currentLang" :selectedLangues="selectedLangues" />
  -->
    <order-process :is_commande="is_commande" :hasModule="hasModule" :hasCommande="hasCommande"
      :reserved_items="reserved_items" :order="order" :SubstractQuanity="SubstractQuanity" :RemoveItem="RemoveItem"
      :AddQuanity="AddQuanity" :currentCurrency="currentCurrency" :restaurant="currentRestau ? currentRestau : {}" />

    <modal name="page_detail" @opened="onOpened" @closed="onClosed">
      <!-- <span class="close_modal close_modal_cart" @click="$modal.hide('page_detail')">
        <div>
        <i class="fas fa-chevron-left"></i>
        </div>
      </span> -->
      <div class="modal_title cart_header" @click="$modal.hide('page_detail')">
        <!-- <span>Detail</span> -->
        <!-- <div class="back_header">
          <i class="fas fa-chevron-left"></i>
        </div> -->
        <div class="modal_down"></div>
      </div>
      <div class="modal_content full_gray ">
        <div class="full full_gray full_gray_panier">
          <div class="detail_item">
            <div class="detail_item_infos">
              <div class="detail_item_img_container">
                <img :src="`htttp://localhost:3333/uploads/menus-items/${selectedItem.image}`" alt=""
                  class="detail_item_img" />
              </div>

              <div class="detail_item_info">
                <div class="detail_item_props">
                  <div class="detail_item_props_left">
                    <h2 class="detail_item_title">{{ selectedItem.title }}</h2>
                    <p v-if="itemsrates.rate">★ {{ itemsrates.rate }}/5</p>
                    <p v-else>★ - /5</p>
                  </div>
                  <div class="detail_item_props_right">
                    <div class="detail_item_price">
                      <span>{{ getPrice(selectedItem.price)
                      }}{{ currentCurrency.symbol }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="detail_item_description">
              <p>{{ selectedItem.observation }}</p>
            </div>

            <div class="detail_item_extras">
              <div v-if="selectedItem.optionsItem">
                <span>
                  {{
                    selectedItem.optionsItem.duree
                    ? `${selectedItem.optionsItem.duree}`
                    : "-"
                  }}</span>
                <span>min</span>
              </div>
              <div v-if="selectedItem.optionsItem">
                <span>
                  {{
                    selectedItem.optionsItem.calories
                    ? selectedItem.optionsItem.calories
                    : "-"
                  }}</span>
                <span>Kcal</span>
              </div>
            </div>
            <div v-if="connected" class="stars" style=" background: #264740;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 80%;
                    border-radius: 5px;
                    align-self: center;
                    margin: 10px 0 0 0;
                  ">
              <img @click="stars = 1" :src="
                itemsrates.rate >= 1 || stars >= 1
                  ? `htttp://localhost:3333/new_images/star_active.png`
                  : `htttp://localhost:3333/new_images/star_white.png`
              " alt="" srcset="" />
              <img @click="stars = 2" :src="
                itemsrates.rate >= 2 || stars >= 2
                  ? `htttp://localhost:3333/new_images/star_active.png`
                  : `htttp://localhost:3333/new_images/star_white.png`
              " alt="" srcset="" />
              <img @click="stars = 3" :src="
                itemsrates.rate >= 3 || stars >= 3
                  ? `htttp://localhost:3333/new_images/star_active.png`
                  : `htttp://localhost:3333/new_images/star_white.png`
              " alt="" srcset="" />
              <img @click="stars = 4" :src="
                itemsrates.rate >= 4 || stars >= 4
                  ? `htttp://localhost:3333/new_images/star_active.png`
                  : `htttp://localhost:3333/new_images/star_white.png`
              " alt="" srcset="" />
              <img @click="stars = 5" :src="
                itemsrates.rate >= 5 || stars >= 5
                  ? `htttp://localhost:3333/new_images/star_active.png`
                  : `htttp://localhost:3333/new_images/star_white.png`
              " alt="" srcset="" />
            </div>
            <div class="fact_item_controls_detail">
              <div class="minus_controle_detail" @click.stop="TriggerSubstractQuanity">
                <span>-</span>
              </div>
              <div class="quantity_controle_detail">
                <span>{{
                  quantities[selectedItem.objectNumber]
                  ? quantities[selectedItem.objectNumber]
                  : 0
                }}</span>
              </div>
              <div class="plus_controle_detail" @click.stop="TriggerAddQuanity">
                <span>+</span>
              </div>
            </div>
          </div>
          <div class="modal-footer modal_buttons">
            <div id="success_back" @click="$modal.hide('page_detail')" class="modal_button button_detail_save">
              <div class="modal_button_text" v-if="quantities[selectedItem.objectNumber]">
                Ajouter {{ quantities[selectedItem.objectNumber] }} articles et
                quitter
              </div>
              <div class="modal_button_text" v-else>Retour</div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <modal name="langueChange" @opened="onOpened" @closed="onClosed" :clickToClose="true"
      @click.self="modal.hide('langueChange')">
      <div class="" style="width : 50%;display:flex;align-self: center;justify-content:center;margin:auto;">
        <!--<div class="custom-select">
          <select @change="changeLangue2($event)" v-model="newItem[currentLang].langue">
            <option v-for="(langue, index) in selectedLangues" :key="`Langue_${index}`">{{ langue.key }}</option>
          </select>
        </div>-->
        <div class="langues" style="width:100%">
      <div v-for="(langue, index) in selectedLangues" :key="`Langue_${index}`"
        :class="`langue  ${index == currentLang ? 'active' : ''}`" @click.stop="changeLangue(index)">
        {{ langue.key }}
      </div>
    </div>
      </div>
    </modal>

    <modal name="profile" @opened="onOpened" @closed="onClosed">
      <div class="modal_content payment_modal full_gray dark_modal">
        <div class="dark_header">
          <img @click="$modal.hide('profile')" src="htttp://localhost:3333/new_images/orange_left_arrow.png"
            alt="" srcset="" />
          <Navmenu v-if="connected || 1==1" :connected="connected" :profile="showprofile" :commandes="showcommande" :about="showresto" :participants="showparticipants" />
        </div>
        <div class="full full_gray center paymement_buttons_full">
          <!--<Navmenu />-->
          <ClientProfile ref="clientProg" />
        </div>
      </div>
    </modal>

    <modal name="login" class="profile_modal" @opened="onOpened" @closed="onClosed">
      <div class="modal_content payment_modal full_gray dark_modal">
        <div class="dark_header" @click="$modal.hide('login')">
          <img src="htttp://localhost:3333/new_images/orange_left_arrow.png" alt="" srcset="" />
        </div>
        <div class="full full_gray center paymement_buttons_full">
          <!--<Navmenu />-->
          <Login />
        </div>
      </div>
    </modal>

    <modal name="participants" class="profile_modal" @opened="onOpened" @closed="onClosed">
      <div class="modal_content payment_modal full_gray dark_modal">
        <div class="dark_header" @click="$modal.hide('participants')">
          <img src="htttp://localhost:3333/new_images/orange_left_arrow.png" alt="" srcset="" />
        </div>
        <div class="full full_gray center paymement_buttons_full">
          <h1 class="participants_header">Participants</h1>
          <div class="participant" v-for="user in leaderusers" :key="`part_${user._id}`">
            <span>{{ user.nom || "" }}{{ user.prenom || "" }} {{ client._id == user._id ? '(Vous)' : '' }}</span>
            <i class="fa-solid fa-user-group-crown" v-if="user.leader"></i>
            <i class="fa-solid fa-user-group" v-else></i>
          </div>
        </div>
      </div>
    </modal>

    <modal name="historique" @opened="onOpened" @closed="onClosed">
      <div class="modal_content payment_modal full_gray dark_modal">
        <div class="dark_header">
          <img @click="$modal.hide('historique')" src="htttp://localhost:3333/new_images/orange_left_arrow.png"
            alt="" srcset="" />
          <Navmenu v-if="connected || 1==1" :connected="connected" :profile="showprofile" :commandes="showcommande" :about="showresto" :participants="showparticipants" />
        </div>
        <div class="full full_gray center paymement_buttons_full">
          <HistoriqueProfile :reserveditems="reserved_items" />
        </div>
      </div>
    </modal>

    <modal name="restaurant_detail" @opened="onOpened" @closed="onClosed">
      <div class="modal_content payment_modal full_gray dark_modal">
        <div class="dark_header" @click="$modal.hide('restaurant_detail')">
          <img src="htttp://localhost:3333/new_images/orange_left_arrow.png" alt="" srcset="" />
        </div>
        <div class="full full_gray center paymement_buttons_full">
          <more-options @clickParent="() => {
            showOptions = true;
          }
            " :changeLangue="changeLangue" :showOptions="showOptions" :restau="currentRestau ? currentRestau : {}"
            :currentLang="currentLang" :selectedLangues="selectedLangues" />
        </div>
      </div>
    </modal>
  </div>
  <div class="loader_container" v-else>
    <img src="htttp://localhost:3333/illustrations/loader.gif" alt="" srcset="" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import OrderProcess from "./orders/order.vue";
import ClientProfile from "./progfidelite/Compte_salon.vue";
import Login from "./progfidelite/Login.vue";
import HistoriqueProfile from "./progfidelite/Historique_salon.vue";
import Navmenu from "./progfidelite/Navmenu.vue";

import MoreOprions from "./wegets/options.vue";
import SecondTheme from "./themes/secondTheme.vue";
import ThirdTheme from "./themes/third.vue";
import MonrestoTheme from "./themes/monresto.vue";
import SevenTheme from "./themes/seven.vue";
import ClassicSevenTheme from "./themes/classicSeven.vue";
import CustomTheme from "./themes/custom.vue";
import AzourTheme from "./themes/azour.vue";
import buildComponents from "./buildComponents.vue";
import SwigiTheme from "./themes/swigi.vue";
import "./styles/detail_item.css";

import { DeviceUUID } from "device-uuid";

export default {
  components: {
    Navmenu,
    Login,
    ClientProfile,
    HistoriqueProfile,
    "more-options": MoreOprions,
    "order-process": OrderProcess,
    "second-theme": SecondTheme,
    "third-theme": ThirdTheme,
    "monresto-theme": MonrestoTheme,
    "seven-theme": SevenTheme,
    "classic-seven-theme": ClassicSevenTheme,
    "custom-theme": CustomTheme,
    "azour-theme": AzourTheme,
    "build-components": buildComponents,
    "swigi-theme": SwigiTheme,
  },
  sockets: {
    connect: function () {
      console.log("socket connected");
    },
  },
  mounted() {
    setTimeout(() => {
      console.log("TOKENACCESS : " + localStorage.getItem("accessToken"));
      this.acc_token = localStorage.getItem("accessToken");
    }, 1000);
    this.restaurantRating(this.$route.params.restaurant)
    this.restaurantRatingCount(this.$route.params.restaurant)
    let menuname = this.$route.params.menu
    this.getMenuName(menuname)
    let payload = {
        restaurant: this.$route.params.restaurant,
        menu: this.$route.params.menu
      }
      this.getTopItems(payload)
    // if (this.acc_token) {
    //   this.connected = true;
    // } else this.connected = false;

    // this.getItemsRates(this.$route.params.restaurant)

    let prams = window.location.href.split("?")[0].split("/");
    let pas = 1;
    let table = null;
    if (prams.length == 6) {
      table = prams[prams.length - 1];
      pas = 2;
    }
    let restaurant_ = prams[prams.length - (pas + 1)];
    let menu_ = prams[prams.length - pas];


    this.getCurrencies().then((r) => {
      if (r.status == 200) {
        this.addCurrencies(r.data.currencies);
      }
    });
    this.getChangeCurrencies().then((r) => {
      if (r.status == 200) {
        this.changeCurrencies = r.data.Changecurrencies;
      }
    });

    this.getLanguesHidden().then((r) => {
      if (r.status == 200) {
        this.langues = r.data;
      }
    });

    this.getMenusBySlug({
      restaurant: restaurant_,
      slug: menu_,
    }).then((r) => {
      console.log(r);
      if (r.status == 200) {
        setTimeout(() => {
          this.loadedMenus(true);
        }, 100);
        this.menu = r.data.data;
        // alert(this.menu[0].indexTemplate)
        console.log("%c consoeleleke", "color:red;font-size:22px");
        console.log(r.data.data);
        this.hasModule = r.data.hasModule;
        this.hasCommande = r.data.hasCommande;
        this.newItem = r.data.data;
        if (!this.newItem[0].is_commande) {
          this.is_commande = false;
        } else {
          this.is_commande = this.newItem[0].is_commande;
        }
      } else {
        this.loadedMenus(true);
      }
    });
    this.getMenuRecords(restaurant_).then((r) => {
      if (r.status == 200) {
        this.getMenusSuccess({
          menus: r.data.data,
          currentRestau: r.data.restau,
        });
      }
    });


    // setTimeout(() => {
    //   // alert("Ddd")
    //   this.$modal.show('login')
    // }, 2000);
    // this.$ws.$on(`order|NEW_ORDER`, (d) => {
    //   console.log(d);
    //   this.createOrderSuccess(d.order);
    // });

    // this.$ws.$on(`order|PREPARING_ORDER`, (d) => {
    //   // this.createOrderSuccess(d.order);
    //   console.log(d);
    //   alert("your order is started ");
    // });
  },
  sockets: {
    connect: function () {
      console.log("socket connected");

      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];
        pas = 2;
      }
      let restaurant_ = prams[prams.length - (pas + 1)];
      let menu_ = prams[prams.length - pas];

      setTimeout(() => {

        this.checkClient({ restaurant: restaurant_, socketId: this.$socket.id });
        this.loader = false;
      }, 200);
    },

    updatesOrder: function (data) {
      console.log(data);
      this.createOrderSuccess(data.order);
    },
  },
  computed: {
    acc_token(){
      return localStorage.getItem("accessToken");
    },
    player_id() {
      return this.client ? this.client._id : null;
    },
    quantities() {
      let values = {};
      this.reserved_items.map((item) => {
        if (this.player_id == item.player_id || item.objectNumber) {
          if (item.objectNumber) {
            if (values[item.objectNumber]) {
              values[item.objectNumber] += item.quantity;
            } else {
              values[item.objectNumber] = item.quantity;
            }
          } else {
            if (values[item.MiMasterObjNum]) {
              values[item.MiMasterObjNum] += item.quantity;
            } else {
              values[item.MiMasterObjNum] = item.quantity;
            }
          }
        }
      });
      return values;
    },
    indexes() {
      let values = {};
      this.reserved_items.map((item, index) => {
        if (this.player_id == item.player_id || item.objectNumber) {
          if (item.objectNumber) {
            values[item.objectNumber] = index;
          } else {
            values[item.MiMasterObjNum] = index;
          }
        }
      });
      return values;
    },
    themeSelected: function () {
      return this.newItem[this.currentLang]
        ? this.newItem[this.currentLang].theme
        : 2;
    },
    listSections: function () {
      return this.newItem[this.currentLang]
        ? this.newItem[this.currentLang].sections
        : [];
    },
    ...mapGetters([
      "client",
      "leaderusers",
      "currencies",
      "flagDataMenus",
      "currentRestau",
      "order",

      "itemsrates",
      "restorating",
      "restoratingcount",
      "suggesteditems",
      "menuName",
    ]),
  },
  data() {
    return {
      connected: false,
      acc_token: null,

      stars: 0,

      recievedItem: {},
      selectedItem: {},
      loader: true,
      is_commande: false,
      defaultCurrency: "",
      hasModule: false,
      hasCommande: "0",
      selectes_ids: [],
      reserved_items: [],
      showOptions: false,
      menu: {},
      langage: "",
      selectedHeader: 0,
      currentSmalerTab: 0,
      currentSmalerSubTab: 0,
      listSectionsSmaller: [],
      indexTab: 0,
      disabled: false,
      lengthNewItem: 1,
      selectedLangues: [{ key: "fr", name: "French", nativeName: "Français" }],
      langues: [],
      down: false,
      currentLang: 0,
      fileHeader: null,
      fileRightSide: null,
      fileLeftSide: null,
      fileFooter: null,
      theme: {
        logo: {
          position: "center",
        },
        header: {
          color: "#000000",
          image: "",
        },
        right: {
          color: "#000000",
          image: "",
        },
        left: {
          color: "#000000",
          image: "",
        },
        footer: {
          color: "#000000",
          image: "",
        },
      },
      currencySymbol: "$",

      currentCurrency: {
        currency_code: "USD",
        name: "United States dollar",
        symbol: "$",
        country_code: "US",
        country_name: "United States",
      },
      changeCurrencies: [],
      currentTabSub: 0,
      indexToEditSubSection: -1,
      drag: 0,
      currentTab: 0,
      options: false,
      categorieToEdit: {},
      subCategorieToEdit: {},
      apiPath1: this.apiPath1,
      urlImageUploaded: "htttp://localhost:3333/logos/logo.png",
      urlImageCategorieUploaded:
        "htttp://localhost:3333/logos/logo.png",
      urlImageSubCategorieUploaded:
        "htttp://localhost:3333/logos/logo.png",
      vueSelectOptions: [],
      vueSelectForm: {
        single: "",
        multiple: [],
      },
      focus: false,
      itemToEdit: { tags: [], optionsItem: { duree: 0, calories: 0 } },
      indexToEditSection: -1,
      themes1: [
        // {
        //   value: 1,
        //   img: "htttp://localhost:3333/themes/theme1.png"
        // },
        {
          value: 2,
          img: "htttp://localhost:3333/themes/theme2.png",
        },
        {
          value: 3,
          img: "htttp://localhost:3333/themes/theme6.png",
        },
        // {
        //   value: 4,
        //   img: "htttp://localhost:3333/themes/theme4.png"
        // },
        // {
        //   value: 5,
        //   img: "htttp://localhost:3333/themes/theme5.png"
        // },
        {
          value: 6,
          img: "htttp://localhost:3333/themes/themeresto.png",
        },
        {
          value: 7,
          img: "htttp://localhost:3333/themes/theme7.png",
        },
        {
          value: 12,
          img: "htttp://localhost:3333/themes/theme12.png",
        },
        {
          value: 13,
          img: "htttp://localhost:3333/themes/new.png",
        },
        {
          value: 14,
          img: "htttp://localhost:3333/themes/azour.png",
        },
        {
          value: 999,
          img: "htttp://localhost:3333/themes/theme13.png",
        },
      ],
      themes: [
        // {
        //   text: "Theme 01",
        //   value: 1
        // },
        {
          text: "Theme 02",
          value: 2,
        },
        {
          text: "Theme 03",
          value: 3,
        },
        // {
        //   text: "Theme 04",
        //   value: 4
        // },
        {
          text: "Theme 05",
          value: 5,
        },
        {
          text: "Theme 06",
          value: 6,
        },
        {
          text: "Theme 07",
          value: 7,
        },
        {
          text: "Theme 12",
          value: 12,
        },
        {
          text: "Theme 999",
          value: 999,
        },
      ],
      newItem: [
        {
          show_subCategories: true,
          name: "The name of the menu",
          theme: 0,
          langue: "fr",
          sections: [
            {
              title: "Categorie 1",
              show_subCategories: true,
              sub_sections: [
                {
                  title: "sub categorie 1",
                  items: [
                    {
                      title: "Article 1",
                      price: 0,
                      show: true,
                      disponible: true,
                      objectNumber: "",
                      observation: "La description de l'article",
                    },
                  ],
                },
              ],
            },
            {
              title: "Categorie 2",
              show_subCategories: true,
              sub_sections: [
                {
                  title: "sub categorie 2",
                  items: [
                    {
                      title: "Article 2",
                      price: 0,
                      show: true,
                      disponible: true,
                      objectNumber: "",
                      observation: "La description de l'article",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    };
  },
  watch: {

    acc_token: function () {
      if (this.acc_token) {
        this.connected = true;
      } else this.connected = false;
      return this.connected;
    },
    stars: function () {
      let payload = {
        restaurant: this.$route.params.restaurant,
        menu: this.$route.params.menu,
        item_id: this.selectedItem.objectNumber,
        rate: this.stars
      };
      console.log(payload)
      this.rateItem(payload)
      // .then(this.stars=0);
    },
    order: function (newVal, oldVal) {

      if (newVal) {
        if (newVal[0].menuItems) {
          // alert("orde1r1")
          let total_payed = 0;
          let payed_items = [];
        
          // if (newVal.values) {
          //   newVal.values.map((values) => {
          //     for (let x = 0; x < values.length; x++) {
          //       const element = values[x];
          //       payed_items.push(
          //         `${element[0].item.MiMasterObjNum}_${element[0].item.player_id}_${element[0].item.quantity}`
          //       );

          //       total_payed += element[0].item.quantity * element[0].item.price;
          //     }
          //   });
          // }

          let reserved_items = [];

          console.log(payed_items);
          let filtred_Array = newVal[0].menuItems.filter((itm) => {
            total_payed -= itm.quantity * itm.unitPrice;
            let is_true = payed_items.includes(
              `${itm.MiMasterObjNum}_${itm.player_id}_${itm.quantity}`
            );
            if (is_true) {
              payed_items.splice(
                payed_items.indexOf(
                  `${itm.MiMasterObjNum}_${itm.player_id}_${itm.quantity}`
                ),
                1
              );
            }
            return !is_true;
          });
          filtred_Array.map((item) => {
            if (item.player_id != this.player_id) {
              reserved_items.push(item);
            } else {
              let existing_item = this.reserved_items.find(
                (ex_item) => ex_item._id == item._id
              );
              if (!existing_item) {
                existing_item = item;
              }
              reserved_items.push(existing_item);
            }
          });
          this.reserved_items
            .filter((item) => !item._id)
            .map((item) => {
              reserved_items.push({ ...item });
            });
          // if (total_payed >= 0) {
          //   reserved_items = [];
          // }
   
          this.reserved_items = [...reserved_items];
        }
      }
    },
    langage: function (newVa) {
      if (!newVa || newVa == "") {
        return;
      }
      let langue = this.langues.find((item) => item.key == newVa);
      this.addLangueToMenu(langue);
      this.langage = "";
    },
    // "currentCurrency.currency_code": function(newVal, prevCode) {
    //   let currentCurrency = this.currencies.find(
    //     (item) => item.currency_code == newVal
    //   );
    //   // this.currentCurrency= Object.assign({},{...currentCurrency})
    //   this.changeCurrency(currentCurrency, prevCode);
    // },
    menu(newVal) {
      console.log("%c HEEEYE", "color :orange ; font-size:22px");
      console.log(newVal);
      this.selectedLangues = [];
      if (!newVal.length) {
        // this.initValues();
      } else {
        newVal.map((item, index) => {
          // SHOW CATEGORIES
          if (!item) {
            return;
          }
          if (!item.hasOwnProperty("show_subCategories")) {
            item.show_subCategories = true;
          }
          // CURRENT LANGUES
          if (item.langue) {
            let langue = this.langues.find(
              (itemLangue) => itemLangue.key == item.langue
            );
            this.selectedLangues.push(langue);
          }
          // GET CURRENT CURRENCY
          if (index == 0) {
            if (item.currency_code) {
              this.defaultCurrency = item.currency_code;
              let crr = item.currency_code;
              this.currentCurrency = crr;
            } else {
              let itemExsit = this.currencies.find(
                (itemFind) => itemFind.currency_code == "USD"
              );
              this.currentCurrency = itemExsit;
            }
          } else {
            if (item.currency_code) {
            } else {
              // let itemExsit = this.currencies.find(
              //   itemFind => itemFind.currency_code == "USD"
              // );
            }
          }
        });
        if (this.selectedLangues.length) {
        } else {
          let exist = this.langues.find((item) => item.key == "fr");
          this.selectedLangues.push(exist);
        }
        if (newVal[0]) {
          this.newItem = [...newVal];
        } else {
          this.newItem = [...newVal];
        }
        if (newVal[0].params) {
          this.theme = { ...newVal[0].params };
        }
        this.lengthNewItem = this.newItem.length;
      }
    },
    fileHeader: function () {
      // this.getBase64()
      if (this.fileHeader) {
        let formData = new FormData();
        formData.append("image", this.fileHeader);
        this.uploadQrCode(formData).then((res) => {
          if (res.ok) {
            this.theme.header.image = res.data;
          }
        });
      } else {
        this.theme.header.image = "";
      }
    },
    fileRightSide: function () {
      // this.getBase64()
      if (this.fileRightSide) {
        let formData = new FormData();
        formData.append("image", this.fileRightSide);
        this.uploadQrCode(formData).then((res) => {
          if (res.ok) {
            this.theme.right.image = res.data;
          }
        });
      } else {
        this.theme.right.image = "";
      }
    },
    fileLeftSide: function () {
      // this.getBase64()
      if (this.fileLeftSide) {
        let formData = new FormData();
        formData.append("image", this.fileLeftSide);
        this.uploadQrCode(formData).then((res) => {
          if (res.ok) {
            this.theme.left.image = res.data;
          }
        });
      } else {
        this.theme.left.image = "";
      }
    },
    fileFooter: function () {
      // this.getBase64()
      if (this.fileFooter) {
        let formData = new FormData();
        formData.append("image", this.fileFooter);
        this.uploadQrCode(formData).then((res) => {
          if (res.ok) {
            this.theme.footer.image = res.data;
          }
        });
      } else {
        this.theme.footer.image = "";
      }
    },
    currentCurrency(newVal) {
      this.currencySymbol = newVal.symbol;
      let currItem = [...this.newItem];
      currItem.currency_code = newVal;
      for (
        let indexNewItem = 0;
        indexNewItem < currItem.length;
        indexNewItem++
      ) {
        this.newItem[indexNewItem] = {
          ...currItem[indexNewItem],
          currency_code: { ...newVal },
        };
        this.newItem[indexNewItem].currency_code = { ...newVal };
        this.$set(this.newItem[indexNewItem], "currency_code", { ...newVal });
      }

      this.newItem = [];
      this.newItem = [...currItem];
    },
  },
  methods: {
    SelectedItemFromTheme(recievedItemClicked){
      this.selectedItem=recievedItemClicked;
      this.$modal.show('page_detail')
    },
    changeName(menuname) {
      menuname = "hi"
      // menuname = this.menu[0].slug;
    },
    showparticipants() {
      document.body.classList.toggle("open");
      this.$modal.hide("restaurant_detail");
      this.$modal.hide("historique");
      this.$modal.hide("profile");
      this.$modal.show("participants");
      // participants
    },
    showprofile() {
      document.body.classList.toggle("open");
      this.$modal.hide("restaurant_detail");
      this.$modal.hide("historique");
      this.$modal.show("profile");
      // this.$refs.profile.show()
    },
    showresto() {
      document.body.classList.toggle("open");
      this.$modal.hide("profile");
      this.$modal.hide("historique");
      this.$modal.show("restaurant_detail");
      // this.$refs.profile.show()
    },
    showcommande() {
      document.body.classList.toggle("open");
      this.$modal.hide("profile");
      this.$modal.hide("restaurant_detail");
      this.$modal.show("historique");
      // this.$refs.profile.show()
    },
    getPrice(value) {
      return parseFloat(value).toFixed(2);
    },
    onOpened() {
      // this.showOptions = true;
      window.scrollTo(0, 1);
      document.getElementsByTagName("html")[0].classList.add("modal-opened");
    },
    onClosed() {
      this.stars = 0;
      document.getElementsByTagName("html")[0].classList.remove("modal-opened");
    },
    triggerAddToCart(item, e) {
      if (e != null) {
        this.selectedItem = { ...item };
        console.log(item)
        console.log(this.$route.params.menu)
        let payload = {
          restaurant: this.$route.params.restaurant,
          menu: this.$route.params.menu,
          item_id: item.objectNumber,
          // item_id:this.selectedItem.objectNumber,
        };
        console.log(payload)
        this.getItemsRates(payload)
        this.$modal.show("page_detail");
      } else {
        this.addToCart(item, null);
      }

      //
    },
    RemoveItem(index) {
      this.reserved_items.splice(index, 1);
    },
    SubstractQuanity(index) {
      this.reserved_items[index].quantity =
        this.reserved_items[index].quantity - 1;
      if (this.reserved_items[index].quantity < 0) {
        this.reserved_items.splice(index, 1);
      }
    },
    AddQuanity(index) {
      this.reserved_items[index].quantity =
        this.reserved_items[index].quantity + 1;
    },
    TriggerSubstractQuanity() {
      let selected_index = -1;
      this.reserved_items.map((item, index) => {
        if (
          item.MiMasterObjNum == this.selectedItem.objectNumber ||
          item.objectNumber == this.selectedItem.objectNumber
        ) {
          if (
            item.player_id == this.player_id ||
            item.objectNumber == this.selectedItem.objectNumber
          ) {
            selected_index = index;
          }
        }
      });
      if (selected_index != -1) {
        this.reserved_items[selected_index].quantity -= 1;
        if (this.reserved_items[selected_index].quantity < 0) {
          this.reserved_items.splice(selected_index, 1);
        }
      }
    },
    TriggerAddQuanity() {

      // return 1;
      let selected_index = -1;
      this.reserved_items.map((item, index) => {
        if (
          item.MiMasterObjNum == this.selectedItem.objectNumber ||
          item.objectNumber == this.selectedItem.objectNumber
        ) {
          if (
            item.player_id == this.player_id ||
            item.objectNumber == this.selectedItem.objectNumber
          ) {
            selected_index = index;
          }
        }
      });
      if (selected_index == -1) {
        this.addToCart(this.selectedItem, {});
      } else {
        this.reserved_items[selected_index].quantity += 1;
      }
    },
    addToCart(item, e) {
      // var audio = new Audio('htttp://localhost:3333/ring1.mp3');
      // audio.play();
      if (!e) {
        e = {};
      }
      if (this.is_commande && (this.hasModule || this.hasCommande)) {
      } else {
        return;
      }
      console.log("%c element", "color:orange;font-size:40px;");
      console.log($(e.target).parents(".my_item_").eq(0));
      // my_item_

      $(e.target).parents(".my_item_").eq(0).prepend(`
        <div class="success_added "  >
          Article bien ajoute avec succees<br />
          <span class="cart"
            ><i class="fa fa-shopping-cart" aria-hidden="true"></i
          ></span>
        </div>
      `);

      setTimeout(() => {
        $(e.target)
          .parents(".my_item_")
          .eq(0)
          .find(".success_added")
          .addClass("showed");
      }, 300);
      setTimeout(() => {
        $(e.target)
          .parents(".my_item_")
          .eq(0)
          .find(".success_added")
          .removeClass("showed");
        setTimeout(() => {
          $(e.target)
            .parents(".my_item_")
            .eq(0)
            .find(".success_added")
            .remove();
        }, 500);
      }, 1000);

      this.selectes_ids.push(item._id);
      setTimeout(() => {
        this.selectes_ids.splice(this.selectes_ids.indexOf(item._id));
      }, 1000);
      let is_exist = this.reserved_items.find(
        (elem) => elem.objectNumber == item.objectNumber
      );
      if (is_exist) {
        let item_index = this.reserved_items
          .map(function (e) {
            return e.objectNumber;
          })
          .indexOf(item.objectNumber);
        this.reserved_items[item_index].quantity =
          this.reserved_items[item_index].quantity + 1;
      } else {
        this.reserved_items.push({
          ...item,
          quantity: 1,
        });
      }
    },
    changeLangue(index) {
      this.currentLang = index;
      this.showOptions = false;
      this.$modal.hide("langueChange")

    },
    changeLangue2(event) {
      this.currentLang = event.target.selectedIndex;
      this.showOptions = false;
      this.$modal.hide("langueChange")
    },
    setCurrentTab(newVal) {
      this.currentTab = newVal;
    },
    findLangue(langue, selectedLangue) {
      let finded = selectedLangue.find((item) => item.key == langue.key);
      if (finded) {
        return true;
      } else {
        return false;
      }
    },
    changeCurrency(currency, prevCode) {
      if (
        this.defaultCurrency != "" &&
        this.defaultCurrency == currency.currency_code
      ) {
        this.currentCurrency = Object.assign({}, { ...currency });
        return;
      }

      let currentCurrencyValue = this.changeCurrencies.find(
        (item) => prevCode == item.currency_code
      );
      let newCurrencyValue = this.changeCurrencies.find(
        (item) => currency.currency_code == item.currency_code
      );
      let currenc =
        (1 / (currentCurrencyValue.value * 1)) * (newCurrencyValue.value * 1);
      let newItem = [...this.newItem];
      for (
        let indexNewItem = 0;
        indexNewItem < this.newItem.length;
        indexNewItem++
      ) {
        newItem[indexNewItem].sections.map((itemSection) => {
          itemSection.sub_sections.map((itemSubSection) => {
            for (let index = 0; index < itemSubSection.items.length; index++) {
              const element = { ...itemSubSection.items[index] };
              element.price = (element.price * currenc).toFixed(2);
              itemSubSection.items[index] = { ...element };
            }
          });
        });
        newItem[indexNewItem] = {
          ...newItem[indexNewItem],
          currency_code: Object.assign({}, { ...currency }),
        };
      }
      this.newItem = [];

      this.newItem = [...newItem];
      this.currentCurrency = Object.assign({}, { ...currency });
    },
    log(param) {
      this.currentTab = param.moved.newIndex;
    },

    ...mapMutations([
      "addCurrencies",
      "addMenusSuccess",
      "getMenusSuccess",
      "loadedMenus",
      "createOrderSuccess",
    ]),
    ...mapActions([
      "getMenusBySlug",
      "getMenuRecords",
      "getLanguesHidden",
      "addMenus",
      "editMenus",
      "controllerMenus",
      "addMenuRecord",
      "uploadImageItem",
      "uploadImageCategorie",
      "uploadQrCode",
      "uploadImageSubCategorie",
      "getCurrencies",
      "getChangeCurrencies",
      "checkClient",
      "rateItem",
      "getItemsRates",
      "restaurantRating",
      "restaurantRatingCount",
      "getTopItems",
      "getMenuName"
    ]),
  },
};
</script>
<style>
.custom-select {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #F05D2E;
  border-radius: 6px;
  padding: 10px;
  background-color: #fff;
  color: #333;
  cursor: pointer;
  user-select: none;
}

.custom-select select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  background-color: transparent;
  font-size: 22px;
  color: #333;
  cursor: pointer;
  outline: none;
  width: 100%;
  padding: 4px;
}

.custom-select::after {
  content: '\f078';
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  pointer-events: none;
}

.custom-select:hover {
  border-color: #F05D2E;
}

.custom-select select:hover {
  color: #F05D2E;
}

.custom-select select:focus+.custom-select::after {
  color: #e74c3c;
}

.custom-select select:disabled+.custom-select {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Styling the dropdown arrow */
.custom-select select::-ms-expand {
  display: none;
}

.modal_down::after {
    content: " ";
    display: block;
    width: 35px;
    height: 35px;
    background: transparent;
    position: absolute;
    top: 12px;
    left: 12px;
    background-image: url("htttp://localhost:3333/new_images/close.png");
    background-size: contain;
    background-position: center;
    cursor: pointer;
    z-index: 99;
  }

.loader_container {
  height: 100vh;
  justify-content: center;
  align-items: center;
  display: flex;
}

.loader_container img {
  width: 40%;
}

body {
  width: 100%;
  overflow-x: hidden;
}

#app,
.full_container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 60px;
}

@media (max-width: 576px) {

  #app,
  .full_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 42px;
  }

  .vm--container {
    max-width: 100%;
    margin-left: 0px;
  }

  .container {
    padding: 0px !important;
  }
}

.my_item_ {
  position: relative;
}

.success_added {
  width: 0%;
  opacity: 0;
  background: black;
  color: #fff;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  left: 6px;
  top: 0px;
  z-index: 99;
  height: 100%;
  /* display: none; */
  overflow: hidden;
  transition: width 0.001s;
  animation-fill-mode: forwards;
  padding-top: 12px;
  font-size: 12px;
  left: 0px;
}

.success_added .cart .fa {
  font-size: 12px;
}

.success_added.showed {
  display: flex;
  width: 100%;
  opacity: 0.9;
  transition: all 0.1s;
}

.back_header {
  position: absolute;
  left: 8px;
  background: #fff;
  width: 36px;
  height: 36px;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  top: 2%;
}

.modal-footer {
  position: fixed;
}

.button_detail_save {
  background: #264740 !important;
}

.profile_modal {
  z-index: 999999 !important;
}

#bv-modal-update .modal-body,
#bv-modal-update {
  background-color: #264740 !important;
}

.participants_header {
  margin-top: 12px;
  margin-bottom: 42px;
}

.participant {
  display: flex;
  width: 90%;
  border: 1px solid #fff;
  background: #fff;
  color: #264740;
  padding: 12px;
  margin-bottom: 12px;
  border-radius: 5px;
  font-weight: bold;
  justify-content: space-between;
  align-items: center;
}
</style>
